export const initSurvey = () => {
  if (window.QSI && window.QSI.API) {
    window.QSI.API.unload();
    window.QSI.API.load();
    window.QSI.API.run();
  }
};
